export const title = 'Register for Event';
export const image = {
  desktop:
    'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/owl-soul-exhibition/contact-form/Desktop.png',
  tablet:
    'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/owl-soul-exhibition/contact-form/Tablet.png',
  mobile:
    'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/owl-soul-exhibition/contact-form/Mobile.png',
};
export const captchaText =
  "\r\rBy registering for Owl's oul art exhibition, you accept that Andersen can email you relevant information about the event. You also agree to the Andersen's <a href='https://policies.google.com/privacy' target='_blank' rel='noreferrer noopener'>Privacy Policy</a>.";
